import { useState } from 'react';
import { api } from '@/services/api';
import { useToast } from '@/shared/toast';

interface Intervention { id: string; date: string; startTime: string; endTime: string; note: string; category?: string }

/**
 * Modal di edit di un intervento da timeline dashboard. PUT su submit.
 * Estratto da DashboardPage per scopo.
 */
export function InterventionEditModal({ it, onClose, onSaved }: {
  it: Intervention;
  onClose: () => void;
  onSaved: () => void;
}): React.JSX.Element {
  const toast = useToast();
  const [date, setDate] = useState(it.date.slice(0, 10));
  const [startTime, setStartTime] = useState(it.startTime?.slice(0, 5) ?? '');
  const [endTime, setEndTime] = useState(it.endTime?.slice(0, 5) ?? '');
  const [note, setNote] = useState(it.note ?? '');
  const [category, setCategory] = useState(it.category ?? 'Altro');

  async function save(): Promise<void> {
    try {
      await api.put(`/interventions/${it.id}`, {
        date: `${date}T00:00:00`,
        category,
        note: note || null,
        startTime: startTime ? `${startTime}:00` : null,
        endTime: endTime ? `${endTime}:00` : null,
      });
      onSaved();
    } catch {
      toast.show('Errore salvataggio', 'error');
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <h3 style={{ marginBottom: 20 }}>✎ Modifica Intervento</h3>

        <div className="form-group">
          <label>Data</label>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Ora Inizio</label>
            <input type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Ora Fine</label>
            <input type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
          </div>
        </div>
        <div className="form-group">
          <label>Categoria</label>
          <select value={category} onChange={e => setCategory(e.target.value)}>
            <option value="Incendio">🔥 Incendio</option>
            <option value="Soccorso">🚑 Soccorso</option>
            <option value="Stradale">🚗 Stradale</option>
            <option value="Altro">📝 Altro</option>
          </select>
        </div>
        <div className="form-group">
          <label>Nota</label>
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={3} />
        </div>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
          <button onClick={onClose}
            style={{ padding: '10px 20px', fontWeight: 600, fontSize: 14, border: 'none', borderRadius: 8, cursor: 'pointer',
                     background: 'linear-gradient(135deg, #6c757d 0%, #5a6268 100%)', color: 'white',
                     boxShadow: '0 2px 6px rgba(108, 117, 125, 0.3)' }}>
            Annulla
          </button>
          <button onClick={save}
            style={{ padding: '10px 20px', fontWeight: 700, fontSize: 14, border: 'none', borderRadius: 8, cursor: 'pointer',
                     background: 'linear-gradient(135deg, #28a745 0%, #218838 100%)', color: 'white',
                     boxShadow: '0 2px 6px rgba(40, 167, 69, 0.3)' }}>
            💾 Salva
          </button>
        </div>
      </div>
    </div>
  );
}

